import CloseIcon from '@mui/icons-material/Close'
import { Dialog, DialogTitle, IconButton } from '@mui/material'
import { FrameworkComponentProps } from '@om1/platform-utils'
import { useCallback, useMemo } from 'react'
import { cohortBlocksEditActions, CriterionNode } from '../../../state'
import { createObservationDateScoreEditDialogComponent } from './ObservationDateScoreEditDialog'
import { createObservationNumericScoreEditDialogComponent } from './ObservationNumericScoreEditDialog'
import { createObservationTextQualifierEditDialogComponent } from './ObservationTextQualifierEditDialog'

const ObservationNumericScoreEditDialogComponent = createObservationNumericScoreEditDialogComponent()
const ObservationDateScoreEditDialogComponent = createObservationDateScoreEditDialogComponent()
const ObservationTextQualifierEditDialogComponent = createObservationTextQualifierEditDialogComponent()

export enum ObservationScoreField {
    Numeric = 'numeric',
    Text = 'text',
    Date = 'date'
}

export type ObservationScoreEditDialogComponentProps = FrameworkComponentProps<
    {
        resultTypeMap: Record<string, string | null>
        criteria?: CriterionNode
    },
    typeof cohortBlocksEditActions
>

export const ObservationScoreEditDialogComponent = ({ state, actions }: ObservationScoreEditDialogComponentProps) => {
    const { resultTypeMap, criteria } = state

    const observationType = useMemo(() => {
        const filterValue = criteria?.filters[0].values[0]

        if (filterValue && resultTypeMap[filterValue]) {
            return resultTypeMap[filterValue]
        }

        return null
    }, [criteria, resultTypeMap])

    const renderQualifierForm = useCallback(() => {
        if (observationType === ObservationScoreField.Numeric) {
            return <ObservationNumericScoreEditDialogComponent />
        }

        if (observationType === ObservationScoreField.Text) {
            return <ObservationTextQualifierEditDialogComponent />
        }

        if (observationType === ObservationScoreField.Date) {
            return <ObservationDateScoreEditDialogComponent />
        }

        return <></>
    }, [observationType])

    const onCancel = () => {
        actions.observationScoreEditDialogTrigger({})
    }

    return (
        <Dialog
            open
            fullWidth
            sx={{
                '& .MuiDialog-container': {
                    '& .MuiPaper-root': {
                        width: '100%',
                        maxWidth: '700px'
                    }
                }
            }}
        >
            <DialogTitle>
                <IconButton
                    aria-label='close'
                    onClick={onCancel}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            {renderQualifierForm()}
        </Dialog>
    )
}
